import { render, staticRenderFns } from "./typeStatic.vue?vue&type=template&id=768e1c78"
import script from "./typeStatic.vue?vue&type=script&lang=js"
export * from "./typeStatic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports